/* STEP 3 · Rule 8 (B-8c, owner 26-Oct-2026) — who may sign a level / stage / form step: the refusal codes of
   review_roles.may_sign (the sign-off bar, the stage sign-off and the form workflow give the same answer) and the stage
   card's line while the answer loads. EN + AR. Loaded from lib/i18n/ by the generated index (STEP 2 · B2). */
export const I18N_S3R8 = {
  en: {
    errors: {
      SIGNOFF_TEAM_ONLY: "Only a member of the engagement team can sign this level — add the person in Team first.",
      SIGNOFF_EQ_REVIEWER_ONLY: "Only the appointed EQ reviewer can sign the EQ reviewer level.",
      SIGNOFF_NO_EQ_REVIEWER: "No EQ reviewer is appointed yet — appoint one on the EQ review page.",
      SIGNOFF_PARTNER_ONLY: "Only the engagement partner can sign the Partner level.",
      SIGNOFF_LEVEL_UNKNOWN: "Unknown sign-off level.",
    },
    s3r8: {
      stageRightsLoading: "Checking who can sign this stage…",
    },
  },
  ar: {
    errors: {
      SIGNOFF_TEAM_ONLY: "لا يوقّع هذا المستوى إلا عضو في فريق المهمة — أضف الشخص في صفحة الفريق أولاً.",
      SIGNOFF_EQ_REVIEWER_ONLY: "لا يوقّع مستوى مراجع جودة الارتباط إلا مراجع الجودة المعيَّن.",
      SIGNOFF_NO_EQ_REVIEWER: "لم يُعيَّن مراجع جودة الارتباط بعد — عيّنه في صفحة مراجعة الجودة.",
      SIGNOFF_PARTNER_ONLY: "لا يوقّع مستوى الشريك إلا شريك المهمة.",
      SIGNOFF_LEVEL_UNKNOWN: "مستوى توقيع غير معروف.",
    },
    s3r8: {
      stageRightsLoading: "جارٍ التحقق ممن يمكنه توقيع هذه المرحلة…",
    },
  },
};

export default I18N_S3R8;
